<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" style="line-height:1.2;">
				<strong><%= device.site_name %><i class="fa fa-angle-right mx-2"></i><%= device.device_info.hostname || device.name %></strong><br />
				<small class="text-info" style="font-size:0.7em; font-weight:normal;"><%= device.company_name %></small>
			</h5>
			<button class="btn btn-link d-inline-block d-md-none" style="position:absolute; right:40px; top:18px;" data-bs-toggle="collapse" href="#terminal-extra-info"><i class="fa fa-fw fa-lg fa-info-circle"></i></button>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body p-0">
			<div class="container">
				<div class="row">
					<div class="col-12 col-md-4 p-0" style="background-color:var(--bs-gray-700);">
						<div class="collapse d-md-block" id="terminal-extra-info">
							<table class="mx-2 mb-0 mt-2" style="font-size:0.8em;">
								<tr>
									<td valign="top" style="width:75px;">Első indítás</td>
									<td class="text-info"><%= Anvil.moment(device.first_start).format('YYYY.MM.DD HH:mm:ss') %></td>
								</tr>
								<tr>
									<td valign="top">Utolsó indítás</td>
									<td class="text-info"><%= Anvil.moment(device.recent_start).format('YYYY.MM.DD HH:mm:ss') %></td>
								</tr>
								<tr>
									<td valign="top">Indítások</td>
									<td class="text-info"><%= device.startups %></td>
								</tr>
							</table>
							<hr class="mx-4 my-2" style="background-color:rgba(0, 0, 0, 0.4);" />
							<div class="text-center mb-2">
								<strong style="color:goldenrod;"><%= Anvil.numeral(device.licence_fee).format('0,0') %> Ft/év</strong>
							</div>
						</div>
					</div>
					<div class="col py-3">
						<%- include('/ui/form', {
							params: [ 'device', device, {
								width: 360
							} ],
							fields: [
								{ type: 'row', fields: [
									{ type: 'col', fields: [
										/*
										{
											type: 'text',
											variant: 'number',
											name: 'licence_fee',
											title: 'Havi díj'
										},
										{
											type: 'text',
											variant: 'number',
											name: 'partner_dividend',
											title: 'Partner jutaléka'
										},
										*/
										{
											type: 'textarea',
											name: 'notes',
											title: 'Megjegyzések',
											attributes: {
												style: 'height:275px;'
											}
										}
									]}
								]}
							]
						}) %>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.save()"><i class="fa fa-check me-2"></i>Mentés</button>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	async save () {
		const res = await Anvil.exec('haccp/haccp/action_save_device', Anvil.page.modal.device)

		// Close modal
		if (res === true) Anvil.page.modal.close()
	}
})
</script>
